import { Pipe, PipeTransform } from '@angular/core';

/** Texto que se muestra cuando no hay nombre del cual sacar iniciales. */
const INICIALES_SIN_NOMBRE = '?';

/** Iniciales (máximo dos) del nombre completo para el avatar: "María Pérez Soto" → "MP". */
@Pipe({ name: 'iniciales' })
export class InicialesPipe implements PipeTransform {
  transform(nombreCompleto: string | null | undefined): string {
    const partes = (nombreCompleto ?? '').trim().split(/\s+/).filter(Boolean);
    if (partes.length === 0) return INICIALES_SIN_NOMBRE;
    if (partes.length === 1) return partes[0][0].toUpperCase();
    return `${partes[0][0]}${partes[1][0]}`.toUpperCase();
  }
}
